export default function warn() {
  typeof window !== 'undefined' && console && console.warn && console.warn(...arguments);
}